/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Section_NotificationsInputs */

const en_us2_profile_section_notifications = /** @type {(inputs: Profile_Section_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

const pt_br2_profile_section_notifications = /** @type {(inputs: Profile_Section_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificações`)
};

const es_419_profile_section_notifications = /** @type {(inputs: Profile_Section_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificaciones`)
};

const pt_pt2_profile_section_notifications = /** @type {(inputs: Profile_Section_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificações`)
};

const fr_fr2_profile_section_notifications = /** @type {(inputs: Profile_Section_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

const de_de2_profile_section_notifications = /** @type {(inputs: Profile_Section_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen`)
};

const it_it2_profile_section_notifications = /** @type {(inputs: Profile_Section_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifiche`)
};

/**
* | output |
* | --- |
* | "Notifications" |
*
* @param {Profile_Section_NotificationsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_section_notifications = /** @type {((inputs?: Profile_Section_NotificationsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Section_NotificationsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_section_notifications(inputs)
	if (locale === "es-419") return es_419_profile_section_notifications(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_section_notifications(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_section_notifications(inputs)
	if (locale === "de-DE") return de_de2_profile_section_notifications(inputs)
	if (locale === "it-IT") return it_it2_profile_section_notifications(inputs)
	return en_us2_profile_section_notifications(inputs)
});
export { profile_section_notifications as "profile.section_notifications" }